import script from "./HonorView.vue?vue&type=script&setup=true&lang=js"
export * from "./HonorView.vue?vue&type=script&setup=true&lang=js"

import "./HonorView.vue?vue&type=style&index=0&id=5b42d528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b42d528"]])

export default __exports__